// Keep in sync with the backend upload rules (10MB, see ApplicationController)
// and the web server's client_max_body_size.
export const MAX_UPLOAD_SIZE_MB = 10;
export const MAX_UPLOAD_SIZE_BYTES = MAX_UPLOAD_SIZE_MB * 1024 * 1024;
